module.exports = __webpack_public_path__ + "img/mk-logo.8b398218.png";